import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useIndexCardsStore } from '@/stores'
import '@/components/IndexCard/IndexCard.css'

export default function IndexCardFormPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [keyword, setKeyword] = useState('')
  const [description, setDescription] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const { addIndexCard } = useIndexCardsStore()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    if (!keyword.trim()) {
      setError(t('index.form.keywordHint'))
      return
    }

    setIsSubmitting(true)
    setError(null)

    try {
      const newIndexCard = await addIndexCard({
        keyword: keyword.trim(),
        description: description.trim() || undefined,
      })
      navigate(`/index/${newIndexCard.id}`)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to create index card')
      setIsSubmitting(false)
    }
  }

  return (
    <div className="index-card-page">
      <header className="index-card-header">
        <Link to="/index" className="btn btn-ghost" style={{ marginBottom: '1rem' }}>
          &larr; {t('common.back')}
        </Link>
        <h1>
          <span className="topic-id-badge topic-id-badge--index">17/</span>
          {t('index.createEntry')}
        </h1>
      </header>

      <form className="index-card-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="keyword">{t('index.form.keywordLabel')}</label>
          <input
            id="keyword"
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder={t('index.form.keywordPlaceholder')}
            autoFocus
          />
          <span className="hint">{t('index.form.keywordHint')}</span>
        </div>

        <div className="form-group">
          <label htmlFor="description">{t('index.form.descriptionLabel')}</label>
          <textarea
            id="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder={t('index.form.descriptionPlaceholder')}
          />
        </div>

        {error && (
          <div className="error-message" style={{ color: '#ef4444', fontSize: '0.9rem' }}>
            {error}
          </div>
        )}

        <div className="form-actions">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => navigate('/index')}
            disabled={isSubmitting}
          >
            {t('common.cancel')}
          </button>
          <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
            {isSubmitting ? t('common.loading') : t('common.create')}
          </button>
        </div>
      </form>
    </div>
  )
}
